module.exports = __webpack_public_path__ + "img/send.01d19c97.svg";